import React from 'react';

import { Button } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../../shared/providers';
import { ErrorState } from '../../../shared/components/ErrorState/ErrorState';
import { logout } from '../../../shared/utils/userInfoUtils/logout/logout';

const NgzAccessNotSupported = () => {
  return (
    <ErrorState
      title="This account is no longer supported"
      description="Support for legacy accounts has been discontinued."
    >
      <Button variant="contained" onClick={() => logout()}>
        Log out
      </Button>
    </ErrorState>
  );
};

angularizeWithProviders(NgzAccessNotSupported, 'ngzAccessNotSupported', {});

export { NgzAccessNotSupported };
